/**
 * VENDORED barrel for the react-router-dom-v5-adapted compass.web
 * page-layout (CORE-1671). Import from here — NEVER from
 * `@crehana/compass.web/page-layout`, which is modern.js-router-coupled
 * and crashes in this app.
 *
 * Unlike the compass.web upstream (and this app's own frontend-learning-admin
 * sibling vendoring), `DashboardPageLayout` here has NO sidebar-based
 * breadcrumb/title inference: this app has no `ProductInfoProvider` and
 * `@crehana/layouts` is pinned at 77.13.54 (predates that API). Title and
 * breadcrumbs are always explicit props.
 */

export { DashboardPageLayout, type TDashboardPageProps } from './dashboard';
export {
  DashboardPageSectionContainer,
  PageLayout,
  PageLayoutBreadcrumb,
  PageLayoutContainer,
  PageLayoutContent,
  PageLayoutHeader,
  PageLayoutSubtitle,
  PageLayoutTitle,
  PageLayoutTop,
  type TPageLayoutBreadcrumbItem,
} from './page-layout';
